import React from "react";

const MarketPlace = () => {
    return <div>MarketPlace</div>;
};

export default MarketPlace;
